module.exports = __webpack_public_path__ + "media/images/hotel_lp-1c127634bf85a46e7d4d1d7d7a156976.jpg";